import UploadImage from '@/components/UploadImage';
import {
  Form,
  Checkbox,
  Button,
  Radio,
  Space,
  Input,
  DatePicker,
  Select,
  message,
} from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

import { StatusEnm } from './type';
import { addOrEdit, getDetail } from '@/api/push';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { AxiosError } from 'axios';

enum typeEnum {
  '弹窗',
  '瀑布流置顶',
  'events随机',
}

enum jumpTypeEnum {
  '链接',
  '投票活动ID',
  'contest列表',
  'AI做图',
}

const typeArr = Object.keys(typeEnum).filter((item) => isNaN(Number(item)));
const jumpTypeArr = Object.keys(jumpTypeEnum).filter((item) =>
  isNaN(Number(item))
);

type TFormValue = Record<string, string | number | (string | number)[]>;

const PushDetail = () => {
  const [form] = Form.useForm();

  const navigator = useNavigate();
  const { id } = useParams();
  // console.log(parmas, "parasms")

  useEffect(() => {
    if (!id) return;
    getDetail({ id })
      .then((res) => {
        const data = res.data.data;
        const payload = {
          ...data,
          createTime: dayjs(data.createTime),
          pushTypeList: data.pushType
            ? data.pushType.split(',').map(Number)
            : [],
        };

        form.setFieldsValue(payload);
      })
      .catch((e: AxiosError<null, null>) => {
        message.error(e.message);
      });
  }, [id]);

  async function onSubmit() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const values: TFormValue = await form.validateFields();

    const params = {
      ...values,
      createTime: dayjs(values.createTime as string).format('YYYY-MM-DD HH:mm'),
      jumpContent: (values.jumpContent ? String(values.jumpContent) : '') ?? '',
      pushType: (values.pushTypeList as (string | number)[]).join(','),
    } as PushConfigEditDTO;

    if (id) {
      params.id = Number(id);
    }

    const res = await addOrEdit(params);
    if (res.status !== 200 || res.data.status !== 200) {
      return message.error(res.data.message);
    }

    message.success(res.data.message);
    onCancel();
  }

  function onCancel() {
    navigator(-1);
  }

  const pushTypeList = (Form.useWatch('pushTypeList', form) || []) as number[];

  const hasPop = useMemo(() => {
    return pushTypeList.includes(0);
  }, [pushTypeList]);

  const hasTop = useMemo(() => {
    return pushTypeList.includes(1);
  }, [pushTypeList]);

  const hasEvents = useMemo(() => {
    return pushTypeList.includes(2);
  }, [pushTypeList]);

  return (
    <div>
      <Form
        form={form}
        initialValues={{
          pushResource: 3,
          status: StatusEnm[StatusEnm[0]],
        }}
      >
        <Form.Item
          label="推送类型"
          name="pushTypeList"
          rules={[{ required: true, message: '请选择推送类型' }]}
        >
          <Checkbox.Group>
            {typeArr.map((item, index) => {
              const value = index;
              let disabled = false;
              if (hasEvents && [0, 1].includes(value)) {
                disabled = true;
              } else if ((hasPop || hasTop) && value === 2) {
                disabled = true;
              }
              return (
                <Checkbox value={value} key={value} disabled={disabled}>
                  {item}
                </Checkbox>
              );
            })}
          </Checkbox.Group>
        </Form.Item>
        <Form.Item noStyle dependencies={['pushTypeList']}>
          {() => {
            return (
              <>
                {hasPop && (
                  <Space>
                    <Form.Item
                      label="弹窗图片（英）"
                      name="popUpImage"
                      rules={[{ required: true }]}
                    >
                      <UploadImage
                        width={800}
                        height={400}
                        maxSize={10}
                        showSizeHint={false}
                        acceptWebp={true}
                      />
                    </Form.Item>
                    <Form.Item
                      label="弹窗图片（日）"
                      name="popUpImageJa"
                      rules={[{ required: true }]}
                    >
                      <UploadImage
                        width={800}
                        height={400}
                        maxSize={10}
                        showSizeHint={false}
                        acceptWebp={true}
                      />
                    </Form.Item>
                  </Space>
                )}
                {hasTop && (
                  <Space>
                    <Form.Item
                      label="瀑布流图片（英）"
                      name="waterfallImage"
                      rules={[{ required: true }]}
                    >
                      <UploadImage
                        width={800}
                        height={400}
                        maxSize={10}
                        showSizeHint={false}
                        acceptWebp={true}
                      />
                    </Form.Item>
                    <Form.Item
                      label="瀑布流图片（日）"
                      name="waterfallImageJa"
                      rules={[{ required: true }]}
                    >
                      <UploadImage
                        width={800}
                        height={400}
                        maxSize={10}
                        showSizeHint={false}
                        acceptWebp={true}
                      />
                    </Form.Item>
                    <Form.Item
                      label="瀑布流图片 横版（英）"
                      name="waterfallImageV2"
                      rules={[{ required: true }]}
                    >
                      <UploadImage
                        width={800}
                        height={400}
                        maxSize={10}
                        showSizeHint={false}
                        acceptWebp={true}
                      />
                    </Form.Item>
                    <Form.Item
                      label="瀑布流图片 横版（日）"
                      name="waterfallImageJaV2"
                      rules={[{ required: true }]}
                    >
                      <UploadImage
                        width={800}
                        height={400}
                        maxSize={10}
                        showSizeHint={false}
                        acceptWebp={true}
                      />
                    </Form.Item>
                  </Space>
                )}
              </>
            );
          }}
        </Form.Item>
        {!hasEvents && (
          <>
            <Form.Item
              label="跳转链接"
              name="jumpType"
              rules={[{ required: true, message: '请选择跳转链接' }]}
            >
              <Radio.Group>
                {jumpTypeArr.map((item, index) => {
                  const value = index;
                  return (
                    <Radio value={value} key={value}>
                      {item}
                    </Radio>
                  );
                })}
              </Radio.Group>
            </Form.Item>
            <Form.Item noStyle dependencies={['jumpType']}>
              {({ getFieldsValue }) => {
                const value = getFieldsValue() as Record<
                  string,
                  string | number | (string | number)[]
                >;
                const jumpType = value.jumpType as jumpTypeEnum;
                if (
                  jumpType ===
                    jumpTypeEnum[
                      jumpTypeEnum[0] as keyof typeof jumpTypeEnum
                    ] ||
                  jumpType ===
                    jumpTypeEnum[jumpTypeEnum[1] as keyof typeof jumpTypeEnum]
                ) {
                  return (
                    <Form.Item
                      name="jumpContent"
                      rules={[{ required: true, message: '请输入跳转链接' }]}
                    >
                      <Input />
                    </Form.Item>
                  );
                }
              }}
            </Form.Item>
          </>
        )}
        <Form.Item
          name="createTime"
          label="发布时间"
          rules={[
            { required: true, message: '请选择发布时间' },
            {
              validator: (_, value: string) => {
                if (dayjs(value).isBefore(dayjs())) {
                  return Promise.reject(new Error('发布时间必须晚于当前时间'));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <DatePicker
            showTime
            placeholder="请选择发布时间(日本时间)"
            style={{ width: '100%' }}
            format="YYYY-MM-DD HH:mm"
          />
        </Form.Item>
        <Space>
          <Form.Item name="status" label="推送状态">
            <Select>
              <Select.Option
                value={StatusEnm[StatusEnm[0] as keyof typeof StatusEnm]}
              >
                {StatusEnm[0]}
              </Select.Option>
              <Select.Option
                value={StatusEnm[StatusEnm[1] as keyof typeof StatusEnm]}
              >
                {StatusEnm[1]}
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="pushResource" label="推送端">
            <Select>
              <Select.Option value={0}>H5</Select.Option>
              <Select.Option value={1}>iOS</Select.Option>
              <Select.Option value={2}>Android</Select.Option>
              <Select.Option value={3}>全覆盖</Select.Option>
            </Select>
          </Form.Item>
        </Space>
        <Form.Item>
          <Space style={{ width: '100%', justifyContent: 'center' }}>
            <Button type="primary" onClick={onSubmit}>
              提交
            </Button>
            <Button onClick={onCancel}>取消</Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
};

export default PushDetail;
